import ApiClient from './ApiClient';

class BillingDashboardAPI extends ApiClient {
  constructor() {
    super('billing_dashboard', { apiVersion: 'v2', accountScoped: true });
  }
}

export default new BillingDashboardAPI();
